import type { VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithRef, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { iconButtonVariants } from './IconButton.variants';

export interface IconButtonProps
  extends Omit<ComponentPropsWithRef<'button'>, 'children'>,
    VariantProps<typeof iconButtonVariants> {
  /** Ikona do wyswietlenia. Rozmiar nadaje wariant `size`. */
  icon: ReactNode;
  /** Opis akcji dla czytnikow ekranu — wymagany, bo przycisk nie ma widocznego tekstu. */
  label: string;
}

/** Przycisk zawierajacy wylacznie ikone (edycja, usuwanie, zamkniecie). */
export function IconButton({
  icon,
  label,
  className,
  variant,
  size,
  type = 'button',
  ...props
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cn(iconButtonVariants({ variant, size }), className)}
      {...props}
    >
      {icon}
    </button>
  );
}
